var $95df037910b72a83$exports = {};
$95df037910b72a83$exports = {
    "alert": `Alerta`,
    "dismiss": `Descartar`
};


export {$95df037910b72a83$exports as default};
//# sourceMappingURL=es-ES.module.js.map
